import { Dropdown } from 'antd';
import classNames from 'classnames';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { ClassNameOnlyProps } from 'components/ozone-component';
// TODO:: remove the styles and make it into styled-components
// eslint-disable-next-line import/no-internal-modules
import styles from '../overview/overview.module.css';

export enum ViewValue {
  Incomplete = 'INCOMPLETE',
  Completed = 'COMPLETED',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
  LastOneWeek = 'LAST_ONE_WEEK',
  LastTwoWeeks = 'LAST_TWO_WEEK',
  All = 'ALL',
}

export enum GroupByValue {
  DueDate = 'DUE_DATE',
  Default = 'DEFAULT',
  Project = 'PROJECT',
}

export enum AssignedToValue {
  Me = 'ME',
  Teams = 'TEAMS',
  Both = 'BOTH',
}

export type Option = {
  label: string | React.ReactNode;
  value: ViewValue | AssignedToValue | GroupByValue;
  options?: Option[];
  subMenuLabel?: string | React.ReactNode;
};

export interface FilterProps extends ClassNameOnlyProps {
  label: string | React.ReactNode;
  options: Option[];
  value: string;
  onChange: (selected: Option) => void;
}

export type CustomFilterProps = Pick<FilterProps, 'onChange'>;

const createOptionHash = (options: Option[], obj) => {
  return options.reduce((_obj, next) => {
    let temp = {};

    if (next.value) {
      temp[next.value] = next;
    }

    if (next.options && next.options?.length > 0) {
      temp = {
        ...temp,
        ...createOptionHash(next.options, temp),
      };
    }

    return {
      ..._obj,
      ...temp,
    };
  }, obj);
};

interface TriggerProps extends ClassNameOnlyProps {
  label: string | React.ReactNode;
  value?: string[] | React.ReactNode[];
}

const StrongText = styled.span`
  font-weight: var(--font-weight-bold);
`;

const Trigger: FC<TriggerProps> = (props) => {
  const { label, value = [] } = props;

  return (
    <>
      <span className={classNames(styles.filter_trigger_label, 'text-02')}>
        {label}
      </span>
      <Breadcrumb className={styles.filter} separator="-">
        {value?.map((v, index) => (
          /* TODO: @Shajansheriff array index as key defeats the purpose */
          // eslint-disable-next-line react/no-array-index-key
          <Breadcrumb.Item key={index}>
            <StrongText>{v}</StrongText>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </>
  );
};

export const Filter: FC<FilterProps> = (props) => {
  const { className, label, options, value, onChange } = props;
  const hash = createOptionHash(options, {});
  const getSelected = (v): Option => hash[v];
  const [selected, setSelected] = useState<Option | undefined>(
    getSelected(value),
  );
  const [selectedItems, setSelectedItems] = useState<Option[]>([
    getSelected(value),
  ]);
  const handleOnClick = (_selectedItem) => {
    const selectedItemsFromKeyPath = _selectedItem.keyPath
      .reverse()
      .map((key) => getSelected(key));

    setSelectedItems(selectedItemsFromKeyPath);
    const selectedItem = selectedItemsFromKeyPath.slice(-1).pop();

    if (selectedItem?.value !== selected?.value) {
      onChange(selectedItem);
    }

    setSelected(selectedItem);
  };
  const { SubMenu } = Menu;
  const menu = () => (
    <Menu
      selectedKeys={(selected?.value && [selected.value]) || undefined}
      multiple={false}
    >
      <Menu.Header>{label}</Menu.Header>

      {options.map((option) =>
        option.options && option.options.length > 0 ? (
          <SubMenu key={option.value} title={option.label}>
            {option.subMenuLabel && (
              <Menu.Header>{option.subMenuLabel}</Menu.Header>
            )}
            {option.options.map((subOption) => (
              <Menu.Item key={subOption.value} onClick={handleOnClick}>
                {subOption.label}
              </Menu.Item>
            ))}
          </SubMenu>
        ) : (
          <Menu.Item key={option.value} onClick={handleOnClick}>
            {option.label}
          </Menu.Item>
        ),
      )}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['hover']} className={className}>
      <Button type="text" size="small">
        <Trigger
          label={label}
          value={selectedItems.map((item) => item.label)}
        />
      </Button>
    </Dropdown>
  );
};
